import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import MobileFirstPageStyle from "./mobile-first-page.module.scss"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const MobileFirstImgDesktop = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulMobileFirstPage{
        mobileFirstReference{
          hero{
            heroDesktopBgImage{
              fluid(maxWidth: 1000, quality: 100) {
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
    }
  `)

  return <Img alt="Mobile First Design Website - First String Digital" className={MobileFirstPageStyle.heroImgDesktop} fluid={data.contentfulMobileFirstPage.mobileFirstReference.hero.heroDesktopBgImage.fluid} />
}

export default MobileFirstImgDesktop
